<template>
  <section class="h-100-trim-header mt-3 mb-5 bg-light-grey">
    <div class="vertical-center text-center" id="loader-text">
      <h4>{{ loadingText }}</h4>
      <p id="video">
        <Animation ref="animation" :filename="postLoadingAnimation" />
      </p>
    </div>
  </section>
</template>

<script>
import Animation from "../../components/loaders/animation";
import { mapGetters } from "vuex";

export default {
  name: "pages-product-post-loading",
  components: {
    Animation
  },
  computed: {
    ...mapGetters({
      loadingText: "ui/postLoadingText",
      postLoadingAnimation: "ui/postLoadingAnimation"
    })
  }
};
</script>

<style scoped>
.vertical-center {
  padding-top: 25%;
}

#loader-text {
  padding-top: 30px;
}

#video video {
  margin-bottom: 30px;
}
</style>
